<template>

    <main>
        <div class="J-dashboard">
            <component-maps/>
        </div>

    </main>

</template>

<script>

import targetlocal from './target-taxis.vue'
import FastMenu from './FastMenu'
import Maps from './Maps'

// Import the EventBus we just created.
import { EventBus } from '../../../helpers/eventbus/event-bus.js'


export default {
    data(){
        return{
            activePopulate:false,
            verificate_status_email: null
        }
    },
    components:{
        'component-maps':Maps,
        targetlocal,
    },
    methods:{
        opencompanyregister(){
            EventBus.$emit('companyregister')
        }
    }
}
</script>

